import { Field, Float, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import type { Product } from '../../product/Product'

@InputType()
export class SerialNumberInputWithId {
  @Field(() => String, { nullable: true })
  code?: string

  @Field(() => String, { nullable: true })
  _id?: string
}

@InputType()
export class ValidateSerialNumberArgs extends ActionArgs {
  @Field(() => String)
  productId: string

  @Field(() => Float)
  quantity: number

  @Field(() => [SerialNumberInputWithId])
  serialNumbers: SerialNumberInputWithId[]

  // Product is not included in GraphQL input, will be fetched internally
  product?: Product
}

export interface IValidateSerialNumber extends IAction<boolean, ValidateSerialNumberArgs> {}
